import styled, { css, keyframes } from "styled-components";

const animateWidth = keyframes`
  0% {
    width: 0;
  }

  100% {
    width: 100px;
  }
`;

export const ProgressStyled = styled.span.attrs({
  className: "progress",
})`
  ${({ theme }) => {
    const { colors, media } = theme;

    return css`
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding-bottom: 20px;
      width: 100%;
      max-width: 450px;
      position: relative;
      gap: 32px;

      ${media.tablet.down} {
        max-width: 380px;
      }

      ${media.mobile.down} {
        display: none;
      }

      .step {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        flex: 1;
        min-width: 0;
        margin-right: 32px;

        &.complete {
          cursor: pointer;
        }

        &.complete .step-number {
          display: none;
        }

        &.complete .step-check {
          display: block;
        }

        &.complete .step-name,
        &.current .step-name {
          color: ${colors.primary.gravity};
        }
      }

      .step:last-child {
        margin-right: 0;
      }

      .circle {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        border: 2px solid ${colors.primary.gravity};
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
      }

      .circle.complete,
      .circle.current {
        background-color: ${colors.primary.gravity};
      }

      .circle.complete svg {
        ${media.tablet.down} {
          width: 11px;
          height: 9px;
        }
      }

      .circle.upcoming {
        background-color: ${colors.primary.white};
        border: 2px solid ${colors.primary.neutralMedium};
        color: ${colors.primary.neutralMedium};
      }

      .step-number {
        font-size: 20px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0px;

        ${media.tablet.down} {
          font-size: 14px;
          line-height: 17px;
        }
      }

      .complete .step-number,
      .current .step-number {
        color: ${colors.primary.electricity};
      }

      .upcoming .step-number {
        color: ${colors.primary.neutralMedium};
      }

      .step-check {
        display: none;
      }

      .step-line {
        position: absolute;
        top: 16px;
        left: 50%;
        transform: translateX(16px);
        height: 2px;
        width: calc(100% + 31px);
        background-color: ${colors.primary.neutralMedium};
        z-index: 0;
      }

      .step:last-of-type .step-line {
        display: none;
      }

      .step.complete .step-line {
        animation: ${animateWidth} 0.75s linear 1;
        background-color: #c4c4c4;
      }

      .step-name {
        margin-top: 10px;
        font-size: 12px;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0px;
        color: ${colors.primary.gravity};

        ${media.tablet.down} {
          font-size: 10px;
          line-height: 14px;
        }
      }
    `;
  }}
`;
